import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M9.49006 3.53013C9.2893 3.34053 9.28026 3.02407 9.46987 2.82332C9.65947 2.62256 9.97593 2.61351 10.1767 2.80312L13.1767 5.63645C13.2767 5.73091 13.3334 5.8624 13.3334 5.99996C13.3334 6.13753 13.2767 6.26901 13.1767 6.36347L10.1767 9.1968C9.97593 9.38641 9.65947 9.37737 9.46987 9.17661C9.28026 8.97585 9.2893 8.65939 9.49006 8.46979L11.5758 6.49996H5.83337C4.63678 6.49996 3.66671 7.47004 3.66671 8.66663V12.8333C3.66671 13.1094 3.44285 13.3333 3.16671 13.3333C2.89056 13.3333 2.66671 13.1094 2.66671 12.8333V8.66663C2.66671 6.91775 4.0845 5.49996 5.83337 5.49996H11.5758L9.49006 3.53013Z"
      fill="currentColor"
    />
  </SvgIcon>
));
